import { buildWorkspacePath } from "@/utils/routes";

export type ArtifactBuilderKey = "proposal" | "quarterlySnapshot";

export interface ArtifactBuilderDiscovery {
  key: ArtifactBuilderKey;
  label: string;
  title: string;
  description: string;
  workspacePath: string;
  keywords: readonly string[];
  steps: readonly string[];
}

export const artifactBuilderDiscovery = {
  proposal: {
    key: "proposal",
    label: "New Proposal",
    title: "Create Proposal",
    description: "Open the proposal builder",
    workspacePath: "artifacts/new/proposal",
    keywords: [
      "proposal",
      "new proposal",
      "create proposal",
      "proposal builder",
      "draft proposal",
    ],
    steps: [
      "Go to Campaigns -> Planning Cycle or open Command Center",
      "Click 'New Proposal' to launch the proposal builder",
      "Use the builder to assemble narrative, scope, and publish-ready copy",
    ],
  },
  quarterlySnapshot: {
    key: "quarterlySnapshot",
    label: "New Quarterly Snapshot",
    title: "Create Quarterly Snapshot",
    description: "Open the quarterly snapshot builder",
    workspacePath: "artifacts/new/quarterly-snapshot",
    keywords: [
      "quarterly snapshot",
      "snapshot",
      "new snapshot",
      "create snapshot",
      "quarterly report",
      "snapshot builder",
    ],
    steps: [
      "Go to Campaigns -> Planning Cycle or open Command Center",
      "Click 'New Quarterly Snapshot' to launch the snapshot builder",
      "Use the builder to prepare the quarterly update and publish-ready draft",
    ],
  },
} as const satisfies Record<ArtifactBuilderKey, ArtifactBuilderDiscovery>;

export const artifactBuilderDiscoveryList = [
  artifactBuilderDiscovery.proposal,
  artifactBuilderDiscovery.quarterlySnapshot,
] as const;

export function buildArtifactBuilderPath(
  clientSlug: string,
  artifactBuilder: ArtifactBuilderKey,
) {
  return buildWorkspacePath(
    clientSlug,
    artifactBuilderDiscovery[artifactBuilder].workspacePath,
  );
}
